import { getProductName } from 'legoland-sdk';
import styled from 'styled-components';
import { Box, Heading, Text, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.section.withConfig({
  displayName: "LimitUsageViewer__Container"
})(["border-top:", ";margin:", ";padding:", ";&:first-child{border-top:none;padding-top:", ";}&:last-child{padding-bottom:", ";}"], tombac.parse('1u solid --neutral-400'), tombac.parse('0 -20u'), tombac.parse('3sp 20u 3sp'), tombac.space(0.5), tombac.space(0.5));
const LimitUsageViewer = ({
  label,
  limit,
  sharedWith,
  usage
}) => /*#__PURE__*/_jsxs(Container, {
  "data-sentry-element": "Container",
  "data-sentry-component": "LimitUsageViewer",
  "data-sentry-source-file": "LimitUsageViewer.tsx",
  children: [/*#__PURE__*/_jsxs(Box, {
    $alignItems: "center",
    $display: "flex",
    as: "header",
    "data-sentry-element": "Box",
    "data-sentry-source-file": "LimitUsageViewer.tsx",
    "data-sentry-element": "Box",
    children: [/*#__PURE__*/_jsx(Heading, {
      level: 5,
      "data-sentry-element": "Heading",
      "data-sentry-source-file": "LimitUsageViewer.tsx",
      "data-sentry-element": "Heading",
      children: label
    }), /*#__PURE__*/_jsx(Text, {
      $ml: "auto",
      $pl: "60u",
      $pt: "0.1em",
      as: "span",
      "data-sentry-element": "Text",
      "data-sentry-source-file": "LimitUsageViewer.tsx",
      "data-sentry-element": "Text",
      children: limit
    })]
  }), sharedWith && /*#__PURE__*/_jsxs(Text, {
    fontSize: 12,
    fontWeight: 500,
    variant: "secondary",
    children: ["Shared limit with ", getProductName(sharedWith)]
  }), usage && /*#__PURE__*/_jsx(Box, {
    $mt: "2sp",
    children: usage
  })]
});
export default LimitUsageViewer;